import React from "react";
import { Stack, FormControl, InputLabel, Select, MenuItem, TextField } from "@mui/material";

export const COMMISSION_TYPES = ["NONE", "NET", "GROSS"];

// NET and GROSS are a percentage of something, so they need a rate; NONE doesn't.
export const rateIsRequired = (commission) => {
  const t = String(commission || "").toUpperCase();
  return t === "NET" || t === "GROSS";
};

// A required rate has to be a positive number — a 0% NET connection is a
// mis-entry, not a free one (that's what NONE is for).
export const rateIsValid = (commission, rate) => {
  if (!rateIsRequired(commission)) return true;
  const n = Number(rate);
  return Number.isFinite(n) && n > 0;
};

// The commission type + rate pair, shared by every dialog that snapshots one so
// the rules above can't drift between them.
export default function CommissionFields({ commission, onCommissionChange, rate, onRateChange, idPrefix = "commission" }) {
  const rateRequired = rateIsRequired(commission);
  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <FormControl size="small" sx={{ minWidth: 140 }}>
        <InputLabel id={`${idPrefix}-type`}>Commission</InputLabel>
        <Select
          labelId={`${idPrefix}-type`}
          label="Commission"
          value={commission}
          onChange={(e) => onCommissionChange(e.target.value)}
        >
          {COMMISSION_TYPES.map((t) => (
            <MenuItem key={t} value={t}>
              {t === "NONE" ? "None" : t}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Rate %"
        size="small"
        type="number"
        sx={{ width: 120 }}
        value={rateRequired ? rate : ""}
        disabled={!rateRequired}
        onChange={(e) => onRateChange(e.target.value)}
        inputProps={{ min: 0, step: 0.5 }}
      />
    </Stack>
  );
}
